<div class="terms-and-conditions-header">
  <h3 [class]="titleClass">{{ 'BOOKING_MODULE.AUTOS_CANCELLATION_POLICIES' | transloco }}</h3>
</div>
<div class="terms-and-conditions-cont">
  <p>
    <span>
      <ng-container *ngIf="!hasCustomPolicies; else customCompanyPolicies">
        {{ 'BOOKING_MODULE.AUTOS_CANCELLATION_POLICIES_TEXT.GENERAL' | transloco }}
      </ng-container>
    </span>
  </p>
</div>

<ng-template #customCompanyPolicies>
  {{ translateCustomKey | transloco }}
</ng-template>